import { useEffect, useRef } from "react";
import { saveProjectEvery } from "@/modules/projects/projectProcessor";
import { Logger } from "@noli/core";
import events from "@/utils/events";
import { loginStore } from "@/modules/login/store";

export enum AutoSaveEvent {
  Stop = "stop",
  Start = "start",
}

export function useSaveProjectEvery(second: number) {
  const timer = useRef<NodeJS.Timeout | null>(null);
  const updateTimer = (timerId: NodeJS.Timeout) => {
    timer.current = timerId;
  };

  const clearTimer = () => {
    if (timer.current) {
      Logger.debug(`stop useSaveProjectEvery >>>> clearTimer timer.current: ${timer.current}`);
      clearTimeout(timer.current);
      timer.current = null;
    }
  };

  const setTimer = () => {
    clearTimer();
    if (loginStore.userInfo.userId) {
      Logger.debug(`Restart useSaveProjectEvery`);
      saveProjectEvery(second, updateTimer);
    }
  };

  useEffect(() => {
    setTimer();
    return () => {
      clearTimer();
    };
  }, [loginStore.userInfo?.userId]);

  useEffect(() => {
    events.on(AutoSaveEvent.Stop, clearTimer);
    events.on(AutoSaveEvent.Start, setTimer);
    return () => {
      events.off(AutoSaveEvent.Stop, clearTimer);
      events.off(AutoSaveEvent.Start, setTimer);
    };
  }, []);

  return {
    timer,
    clearTimer,
  };
}
